<template>
  <div>
    <p v-if="isRereview || allowOrderReview">
      <order-review-timer v-model="time"/>
    </p>
    <div style="margin-bottom: 10px;">

      <!--保存修改-->
      <order-save-answer-button
        v-if="allowUserModifyAnswer"
        :id="orderDetail.orderid"/>

      <!--审核-->
      <order-review-button
        v-if="allowOrderReview"
        :salary="orderDetail.salary"
        @pass="reviewOrderPass"
        @not-pass="reviewOrderNotPass"/>

      <!--复审-->
      <order-rereview-button
        v-if="isRereview"
        :salary="orderDetail.salary"
        :components="{ prolongTime: false }"
        @pass="rereviewOrderPass"
        @not-pass="reviewOrderNotPass"/>

    </div>
    <div>
      <template v-if="orderDetail.locked || allowOrderReview || allowUserModifyAnswer">
        <!--锁定审核-->
        <order-lock-button :locked="orderDetail.locked"
                           :id="orderDetail.orderid"
                           :lock-reason="orderDetail.lock_reason"/>
      </template>
    </div>
  </div>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import OrderReviewTimer from '@views/order-review/components/OrderReviewTimer'
import OrderReviewFinishButton from '@views/order-review/components/OrderReviewFinishButton'
import OrderSaveAnswerButton from '@views/order-review/components/OrderSaveAnswerButton'
import OnekeyReviewButton from '@views/order-review/components/OnekeyReviewButton'
import OrderRereviewButton from '@views/order-review/components/OrderRereviewButton'
import OrderLockButton from '@views/order-review/components/OrderLockButton'
import OrderReviewReadCacheButton from '@views/order-review/components/OrderReviewReadCacheButton'
import OrderReviewButton from '../components/OrderReviewButton'

export default {
  components: {
    OrderReviewButton,
    OrderReviewReadCacheButton,
    OrderLockButton,
    OrderRereviewButton,
    OnekeyReviewButton,
    OrderSaveAnswerButton,
    OrderReviewFinishButton,
    OrderReviewTimer,
  },
  mixins: [],
  props: {},
  data () {
    return {
      time: 0,
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowOrderReview',
      'allowUserModifyAnswer',
    ]),
    isRereview () {
      return this.orderDetail.status === '40'
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    /**
     * 复审通过请求
     */
    rereviewOrderPass (data) {
      let params = {
        id: this.orderDetail.orderid,
        salary: this.orderDetail.salary,
        // WARNING: 此模块已经没了
        templateresultjson: JSON.stringify(QuestionReview().getRecoveryAnswers()),
        sec_consumed: this.time,
        review_message: data.message,
      }
      request.common('reviewTekeOrderPass', params).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        this.$alert('已确认订单结果！', '审核成功', {type: 'success'})
      })
    },
    /**
     * 审核通过请求
     */
    reviewOrderPass (data) {
      let params = {
        id: this.orderDetail.orderid,
        salary: data.salary,
        // WARNING: 此模块已经没了
        templateresultjson: JSON.stringify(QuestionReview().getRecoveryAnswers()),
        sec_consumed: this.time,
      }
      request.common('reviewOrderPass', params).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        this.$alert('已确认订单结果！', '审核成功', {type: 'success'})
      })
    },
    /**
     * 审核不通过请求
     */
    reviewOrderNotPass ({message, prolongTime}) {
      request.common('reviewOrderNotPass', {
        id: this.orderDetail.orderid,
        errormessage: message,
        specifiedEndTime: prolongTime,
        // WARNING: 此模块已经没了
        templateresultjson: JSON.stringify(QuestionReview().getRecoveryAnswers()),
        sec_consumed: this.time,
      }).then(() => {
        this.$store.dispatch('setOrderDetail', {id: this.orderDetail.orderid})
        this.$alert('订单已退回！', '审核成功', {type: 'success'})
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/teke-order-review/pages/TekeOrderReviewButtons.vue